import React, { useState } from 'react';
import NewLocalSettings from './LocalSettings';
import ParticipantStack from '../containers/ParticipantStack';
import { VideoDeviceInfo, AudioDeviceInfo, DeviceManager } from '@azure/communication-calling';
import { Stack } from '@fluentui/react';
import {
  fullHeightStyles,
  paneHeaderStyle,
  settingsContainerStyle,
    paneHeaderTextStyle,
    ratingsContainerStyle
} from './styles/CommandPanel.styles';
import Footer from './Footer';
import Ratings from './Ratings';
import ProblemStatement from './ProblemStatement';
import RatingsSection from './RatingsSection';
import { InfoIcon } from '@fluentui/react-icons-northstar';
import CustomPopup from './CustomPopup';
import { Interpretation, ParticipantInfo, ParticipantModel } from '../Utils/participantInfo';

export interface CommandPanelProps {
  selectedPane: string;
  videoDeviceInfo: VideoDeviceInfo;
  videoDeviceList: VideoDeviceInfo[];
  audioDeviceList: AudioDeviceInfo[];
  audioDeviceInfo: AudioDeviceInfo;
  setSelectedPane: any;
  setVideoDeviceInfo(device: VideoDeviceInfo): void;
  setAudioDeviceInfo(device: AudioDeviceInfo): void;
  deviceManager: DeviceManager;
}
export enum CommandPanelTypes {
  None = 'none',
  People = 'People',
    Settings = 'Settings',
    Chat = 'Chat',
    Ratings = 'Ratings',
    ProblemStatement = 'Problem Statement'
}


export default (props: CommandPanelProps): JSX.Element => {

    const modelone: ParticipantInfo = ParticipantModel();

   const [isToolTipShow, setToolTipShow] = useState(false);
    const togglePopupClose = (isShow: boolean) => {
        setToolTipShow(isShow);
    }

    const popupBodyContent = () => {
        return (
            <div className="tooltipMailDiv">
                <table id="Interpretation" width="100%">
                    <tr>
                        <th>Weight</th>
                        <th>Interpretation</th>
                    </tr>
                    {
                        App1()
                    }
                </table>
            </div>
        );
    }

    const App1 = () => {
        if (modelone != undefined && modelone.interpretationList != undefined) {
            const nterpretationList = modelone.interpretationList as Interpretation[];
            const App2 = nterpretationList.map((nterpretation) => (
                <tr key={nterpretation.iWeight}>
                    <td>{nterpretation.iWeight}</td>
                    <td>{nterpretation.interpretationText}</td>
                </tr>
            ));
            return App2;
        } else {
            const App2 = () => (<div></div>);
            return App2;
        }
    }

  return (
      <Stack styles={fullHeightStyles}>
      <Stack.Item className={paneHeaderStyle}>
              <div className={paneHeaderTextStyle}>
                  {props.selectedPane !== CommandPanelTypes.None && (props.selectedPane)}
                  {props.selectedPane === CommandPanelTypes.Ratings && (
                    <InfoIcon onClick={() => { togglePopupClose(true); }} style={{ marginBottom: "10px", marginLeft: "5px" }} />
                  ) }
              </div>

      </Stack.Item>

      {props.selectedPane === CommandPanelTypes.People && (
        <Stack.Item styles={fullHeightStyles}>
          <ParticipantStack />
        </Stack.Item>
      )}
      {props.selectedPane === CommandPanelTypes.People && (
        <Stack.Item>
          <Footer />
        </Stack.Item>
      )}
      {props.selectedPane === CommandPanelTypes.Settings && (
        <Stack.Item>
          <div className={settingsContainerStyle}>
            <NewLocalSettings
              videoDeviceList={props.videoDeviceList}
              audioDeviceList={props.audioDeviceList}
              audioDeviceInfo={props.audioDeviceInfo}
              videoDeviceInfo={props.videoDeviceInfo}
              setVideoDeviceInfo={props.setVideoDeviceInfo}
              setAudioDeviceInfo={props.setAudioDeviceInfo}
              deviceManager={props.deviceManager}
            />
          </div>
        </Stack.Item>
          )}
          {props.selectedPane === CommandPanelTypes.Ratings && (
              <Stack.Item styles={fullHeightStyles}>
                  <div className={ratingsContainerStyle}>
                      <RatingsSection />
                  </div>
              </Stack.Item>

          )}
          {props.selectedPane === CommandPanelTypes.ProblemStatement && (
              <Stack.Item styles={fullHeightStyles}>
                  <div className={ratingsContainerStyle}>
                      <ProblemStatement />

                  </div>

              </Stack.Item>

          )}

          {/*{ratingIsShowedOnce < 2 && (*/}
          {/*    <Stack.Item styles={fullHeightStyles} id="ratingStackMain" style={{ display: props.selectedPane === CommandPanelTypes.Ratings ? 'block' : 'none' }}>*/}
          {/*        <div className={ratingsContainerStyle}>*/}
          {/*            <Ratings />*/}

          {/*        </div>*/}

          {/*    </Stack.Item>*/}

          {/*)}*/}
          {isToolTipShow && (
              <CustomPopup
                  BodyContent={popupBodyContent}
                  btnCancel=""
                  btnConfirm=""
                  lblTitle="Interpretation"
                  ConfirmHandler={popupBodyContent}
                  togglePopupClose={() => { togglePopupClose(false); }}
                  popupHeight="350px"
                  isShowCloseButton= "true" 
              />)
          }
    </Stack>
  );
};
